/* eslint-disable camelcase */
import { ethers } from 'ethers'
import { ChainId, ROUTERS_MAP, RouterVersion, WNATIVE } from '@nominex/nomiswap-sdk'
import { staticProvider } from 'libs/wagmi' // TODO: try to use current provider
// Addresses
import {
  getFarmingHelperAddress,
  getLaunchpoolMigratorAddress,
  getMulticallAddress,
  getNomiswapEPCSFactoryAddress,
  getNomiswapEPCSRouterAddress,
  getPoolFactoryAddress,
  getReinvestAddress,
  getStableSwapMigratorAddress,
} from 'utils/addressHelpers'

// Contract factories
import {
  IBep20Bytes32Contract__factory,
  IBep20Contract__factory,
  IBoostingMigratorContract__factory,
  IBoostingServiceContract__factory,
  IFarmingHelperContract__factory,
  ILaunchpoolMigratorContract__factory,
  ILpTokenContract__factory,
  IMulticallContract__factory,
  INomiswapEPCSFactory__factory,
  INomiswapEPCSPair__factory,
  INomiswapEPCSRouter__factory,
  INomiswapRouter04__factory,
  IPoolFactoryContract__factory,
  IReinvestContract__factory,
  IStableSwapMigratorContract__factory,
  IStakingServiceContract__factory,
  ISupplierContract__factory,
  IWethContract__factory,
} from 'contracts/types'

//
// Helpers
//
export const getLaunchpoolMigratorContract = (signer?: ethers.Signer | ethers.providers.Provider) =>
  ILaunchpoolMigratorContract__factory.connect(getLaunchpoolMigratorAddress(), signer ?? staticProvider[ChainId.BSC])

export const getBoostingMigratorContract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) =>
  IBoostingMigratorContract__factory.connect(address, signer ?? staticProvider[ChainId.BSC])

export const getBoostingServiceContract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) =>
  IBoostingServiceContract__factory.connect(address, signer ?? staticProvider[ChainId.BSC])

export const getFarmingHelperContract = (chainId: ChainId, signer?: ethers.Signer | ethers.providers.Provider) =>
  IFarmingHelperContract__factory.connect(getFarmingHelperAddress(chainId), signer ?? staticProvider[chainId])

export const getBep20Contract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) =>
  IBep20Contract__factory.connect(address, signer ?? staticProvider[ChainId.BSC])

export const getBep20Bytes32Contract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) =>
  IBep20Bytes32Contract__factory.connect(address, signer ?? staticProvider[ChainId.BSC])

export const getLpTokenContract = (address: string, signer?: ethers.Signer | ethers.providers.Provider) =>
  ILpTokenContract__factory.connect(address, signer ?? staticProvider[ChainId.BSC])

export const getStakingServiceContract = (
  contractAddress: string,
  chainId: ChainId,
  signer?: ethers.Signer | ethers.providers.Provider,
) => IStakingServiceContract__factory.connect(contractAddress, signer ?? staticProvider[chainId])

export const getMulticallContract = (chainId: ChainId, signer?: ethers.Signer | ethers.providers.Provider) =>
  IMulticallContract__factory.connect(getMulticallAddress(chainId), signer ?? staticProvider[chainId])

export const getReinvestContract = (signer?: ethers.Signer | ethers.providers.Provider) =>
  IReinvestContract__factory.connect(getReinvestAddress(), signer ?? staticProvider[ChainId.BSC])

export const getPoolFactoryContract = (signer?: ethers.Signer | ethers.providers.Provider) =>
  IPoolFactoryContract__factory.connect(getPoolFactoryAddress(), signer ?? staticProvider[ChainId.BSC])

export const getSupplierContract = (contractAddress: string, signer?: ethers.Signer | ethers.providers.Provider) =>
  ISupplierContract__factory.connect(contractAddress, signer ?? staticProvider[ChainId.BSC])

export const getStableSwapMigratorContract = (signer?: ethers.Signer | ethers.providers.Provider) =>
  IStableSwapMigratorContract__factory.connect(getStableSwapMigratorAddress(), signer ?? staticProvider[ChainId.BSC])

export const getRouterContract = (
  version: RouterVersion,
  chainId: ChainId,
  signer?: ethers.Signer | ethers.providers.Provider,
) => INomiswapRouter04__factory.connect(ROUTERS_MAP[chainId][version], signer ?? staticProvider[chainId])

export const getWethContract = (chainId: ChainId, signer?: ethers.Signer | ethers.providers.Provider) => {
  if (!WNATIVE[chainId]) {
    throw new Error(`WNATIVE not configured for chainId ${chainId}`)
  }
  return IWethContract__factory.connect(WNATIVE[chainId].address, signer ?? staticProvider[chainId])
}

export const getNomiswapEPCSFactory = (chainId: ChainId, signer?: ethers.Signer | ethers.providers.Provider) =>
  INomiswapEPCSFactory__factory.connect(getNomiswapEPCSFactoryAddress(chainId), signer ?? staticProvider[chainId])

export const getNomiswapEPCSPairContract = (
  chainId: ChainId,
  address: string,
  signer?: ethers.Signer | ethers.providers.Provider,
) => INomiswapEPCSPair__factory.connect(address, signer ?? staticProvider[chainId])

export const getNomiswapEPCSRouter = (chainId: ChainId, signer?: ethers.Signer | ethers.providers.Provider) =>
  INomiswapEPCSRouter__factory.connect(getNomiswapEPCSRouterAddress(chainId), signer ?? staticProvider[chainId])
